import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Randomcode } from "../../components_root/rendom_code";
import { Toast } from '../../components_root/ToastContext';
import { MdArrowBackIos, MdClose, MdDownload, MdUpload } from "react-icons/md";
import { Save_voucher } from "../vouchers_root/save_voucher";
import { Create_ledger_account } from "../ledger_accounts_root/Create_ledger_account";
import { Ledger_accounts_manager } from "../ledger_accounts_root/ledger_accounts_manager";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Pos_receipt_master_create() {
    const [vouchers, setVouchers] = useState("");
    const [description, setDescription] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [slug, setSlug] = useState("");
    const [editable, setEditable] = useState(false);
    const [amount, setAmount] = useState();
    const [paypublic, setPaypublic] = useState(false);
    const [voucher_type, setVoucher_type] = useState("receipt");
    const servicetablename = "accountingfinancedb";

    const handleCreate = async () => {

        if (!vouchers || !vouchers.trim()) {
            Toastshow("Please enter oucher name.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        const logo_url = "https://firebasestorage.googleapis.com/v0/b/aoozpayment.firebasestorage.app/o/icons%2Fthumbnail.jpg?alt=media&token=d4f94427-39a3-4f2a-a575-9b4178b23eba";
        const ledger_account = true;
        //
        const voucherid = Randomcode(16);
        const data = {
            voucherid,
            voucher: vouchers,
            slug,
            paypublic,
            editable,
            description: description,
            amount: isNaN(Number(amount)) ? 0 : Number(amount),
            usecase_type: true,
            voucher_ledger: "user",
            voucher_type,
            entry_type:true,
            logo_url,
             status: false, 
            ledger_account
            // Add other necessary fields here
        };
        const result = await Save_voucher(data);
        if (result.success) {
            if (ledger_account === true) {
                const accountguid = Randomcode(22);
                const data = {
                    name: vouchers,
                    accountguid,
                    mobile: "",
                    slug: slug + "ac",
                    description: description,
                    account_type: "master",
                    status: true,
                    // Add other necessary fields here
                };
                const result = await Create_ledger_account(data);
                if (result.success) {
                    const result = await Ledger_accounts_manager({
                        accountsmanagerid: accountguid + "" + voucherid,
                        accountguid,
                        voucherid,
                        account_type: "master",
                        ledger_type: "=",
                        status: true,
                    })
                }
            }
            if (result.success) {
            }
            setVouchers("");
            setAmount(0);
            setPaypublic(false);
            setEditable(false);
            setDescription("");
            Toastshow("Voucher saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };


    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    return (
        <div >
            <div className="items-back b-1 rounded p-2">

                <table>
                    <tr>
                        <td><div className="text-h2 bold">Receipt name</div></td>
                    </tr>
                    <tr>
                        <td><input type="text" className="p-2" value={vouchers} onChange={(e) => {
                            setVouchers(e.target.value);
                            setSlug(normalize(normalize(e.target.value + "-" + Randomcode(2))));

                        }} maxLength={30} placeholder="Enter Receipt name" /></td>
                    </tr>

                    <tr>
                        <td><div className="text-h2 bold">Description</div></td>
                    </tr>
                    <tr>
                        <td><textarea className="p-2" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                    </tr>
                    <tr>
                        <td >

                            <table>
                                <tr>
                                    <td width={20}><span className="text-h1">₹</span></td>
                                    <td>
                                        <input
                                            type="text"
                                            maxLength={10}
                                            className="p-2 bold text-h1"
                                            placeholder="Enter amount"
                                            value={amount}
                                            onChange={(e) => {
                                                let v = e.target.value;

                                                // allow only digits and dot
                                                v = v.replace(/[^0-9.]/g, "");
                                                // prevent more than one dot
                                                const parts = v.split(".");
                                                if (parts.length > 2) {
                                                    v = parts[0] + "." + parts.slice(1).join("");
                                                }
                                                e.target.value = v;
                                                setAmount(e.target.value);
                                            }}
                                        />
                                    </td>
                                    <td width={90}>

                                        <label>
                                            <input
                                                type="checkbox"

                                                checked={editable}
                                                onChange={(e) => setEditable(e.target.checked)}
                                            />
                                            <a className="text-h2">Editable</a>
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </td>

                    </tr>
                    {/* <tr>
                        <td>
                            <div className="">
                                <table className="table-fixed">
                                    <tr>
                                        <td>
                                            <div
                                                onClick={() => setVoucher_type("receipt")}
                                                className={`fill p-2 cursor ${voucher_type === "receipt" ? "button-ui green-back" : "button-ui2"}`}
                                            >
                                                <MdDownload className="icon" />
                                                Receipt
                                            </div>
                                        </td>

                                        <td>
                                            <div
                                                onClick={() => setVoucher_type("payment")}
                                                className={`fill p-2 cursor ${voucher_type === "payment" ? "button-ui red-back" : "button-ui2"}`}
                                            >
                                                <MdUpload className="icon" />
                                                Payment
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr> */}

                    {/* <tr>
                        <td>

                            <label>
                                <input
                                    type="checkbox"

                                    checked={paypublic}
                                    onChange={(e) => setPaypublic(e.target.checked)}
                                />
                                <a className="text-h3">Mark voucher Pay Public or Unmark Staff Only</a>
                            </label>

                        </td>
                    </tr> */}
                </table>
                <br />
                <div className="button-ui p-22 fill text-h1 cursor" onClick={() => handleCreate()}>Create & Continue</div>
            </div>
        </div>
    );
}
